import { Card } from 'version-two/components/AuthCard/AuthCard.styles';

function AuthCard({ children }) {
  return <Card>{children}</Card>;
}

export default AuthCard;
